// extracted by mini-css-extract-plugin
export var footer = "_mk-5";
export var fulfillmentInput = "_mk-0";
export var shipDateInput = "_mk-1";
export var shipmentModal = "_mk-2";
export var shipmentModalContent = "_mk-3";
export var tableContainer = "_mk-4";